import React, { useEffect, useRef, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";

const Topbar = () => (
  <div className="w-full overflow-hidden border-b border-cyan-500/10 bg-[#06101f]/80 py-2 backdrop-blur-xl">

    <div className="whitespace-nowrap animate-scroll px-4 text-xs font-medium tracking-[0.08em] text-cyan-100 md:text-sm">

      <span className="mx-10">
        Welcome to Asiduo Solutions!
      </span>

      <span className="mx-10">
        We provide Software Solutions, Electrical Projects Consultation, and Graphic Design Services.
      </span>

      <span className="mx-10">
        Domain Registration • Hosting • SEO • Mobile Apps • Full Stack Development
      </span>

      <span className="mx-10">
        Your success is our mission!
      </span>

    </div>

    <style>{`
      @keyframes scroll {
        0% {
          transform: translateX(100%);
        }

        100% {
          transform: translateX(-100%);
        }
      }

      .animate-scroll {
        display: inline-block;
        min-width: 100%;
        animation: scroll 24s linear infinite;
      }
    `}</style>

  </div>
);


const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  const isHomeOverlayRoute = location.pathname === "/";

  const token = localStorage.getItem("token");

  const desktopLinkClass = `
    text-slate-100
    hover:text-cyan-300
    rounded-2xl
    px-4
    py-2
    text-[14px]
    font-semibold
    tracking-wide
    transition-all
    duration-300
    hover:bg-white/10
    hover:backdrop-blur-xl
    hover:shadow-[0_0_20px_rgba(34,211,238,0.15)]
  `;

  const navBackgroundClass =
    "border-b border-cyan-500/10 bg-[#020817]/80 shadow-[0_8px_40px_rgba(0,0,0,0.35)] backdrop-blur-xl";

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // Close menu when clicking outside
  useEffect(() => {
    if (!menuOpen) return;
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <div className="fixed inset-x-0 top-0 z-[100] h-[112px]">

      {/* TOPBAR */}
      <Topbar />

      {/* NAVBAR */}
      <nav
        className={`relative flex w-full items-center justify-between overflow-visible px-6 py-3 md:px-10 ${navBackgroundClass}`}
      >

        {/* LOGO */}
        <div className="flex items-center flex-shrink-0">

          <Link to="/">
            <img
              src="/images/AS logo 1.png"
              alt="AS Logo"
              loading="eager"
              decoding="async"
              className="h-[58px] w-auto drop-shadow-[0_0_20px_rgba(34,211,238,0.4)] transition-all duration-300 hover:scale-110 sm:h-[64px]"
            />
          </Link>

        </div>

        {/* DESKTOP LINKS */}
        <div className="hidden md:flex flex-1 justify-center gap-2 lg:gap-3">

          <Link to="/domain" className={desktopLinkClass}>
            Domain
          </Link>

          <Link to="/email" className={desktopLinkClass}>
            Email
          </Link>

          <Link to="/hosting" className={desktopLinkClass}>
            Website Engagement
          </Link>

          <Link to="/ppc" className={desktopLinkClass}>
            PPC
          </Link>

          <Link to="/seo" className={desktopLinkClass}>
            SEO
          </Link>

          <Link to="/services" className={desktopLinkClass}>
            Website Development
          </Link>

          <Link to="/ssl" className={desktopLinkClass}>
            SSL
          </Link>

          <Link
            to="/mobile-app-developments"
            className={desktopLinkClass}
          >
            Android/iOS App Development
          </Link>

          <Link
            to="/existing-projects-updates"
            className={desktopLinkClass}
          >
            Existing Project Updates
          </Link>

        </div>

        {/* RIGHT SECTION */}
        <div className="ml-3 flex items-center gap-3">

          {/* LOGIN BUTTON */}
          {!token && (
            <Link
              to="/login"
              title="Login"
              className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-cyan-400/20 bg-white/10 text-cyan-300 shadow-[0_0_25px_rgba(34,211,238,0.15)] backdrop-blur-xl transition-all duration-300 hover:scale-110 hover:border-cyan-300 hover:bg-cyan-400/10"
            >

              <svg
                className="h-5 w-5"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.9"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >

                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 6.75a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.5 20.1a7.5 7.5 0 0 1 15 0"
                />

              </svg>

            </Link>
          )}

          {/* MY MAILBOXES BUTTON */}
          {token && (
            <Link
              to="/my-domains"
              className="hidden rounded-2xl border border-cyan-400/30 bg-cyan-500/10 px-4 py-2 text-sm font-bold text-cyan-200 transition-all duration-300 hover:bg-cyan-500/20 md:inline-flex"
            >
              My Domains
            </Link>
          )}

          {token && (
            <Link
              to="/my-mailboxes"
              className="hidden rounded-2xl border border-fuchsia-400/30 bg-fuchsia-500/10 px-4 py-2 text-sm font-bold text-fuchsia-200 transition-all duration-300 hover:bg-fuchsia-500/20 md:inline-flex"
            >
              My Mailboxes
            </Link>
          )}

          {/* LOGOUT BUTTON */}
          {token && (
            <button
              onClick={handleLogout}
              className="rounded-2xl bg-gradient-to-r from-rose-500 to-red-600 px-5 py-2 text-sm font-semibold text-white shadow-lg transition-all duration-300 hover:scale-105"
            >
              Logout
            </button>
          )}

          {/* MOBILE MENU BUTTON */}
          <button
            className="md:hidden focus:outline-none"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >

            <svg
              className={`h-8 w-8 transition-all duration-300 hover:scale-110 ${
                isHomeOverlayRoute
                  ? "text-cyan-300"
                  : "text-white"
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >

              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />

            </svg>

          </button>

        </div>

        {/* MOBILE MENU & OVERLAY */}
        {menuOpen && (
          <>
            {/* Overlay (z-50 to ensure above all content, below menu) */}
            <div
              className="fixed inset-0 z-50 md:hidden"
              style={{ background: 'rgba(0,0,0,0.15)' }}
            />
            {/* Menu (z-60 to ensure above overlay) */}
            <div
              ref={menuRef}
              className="absolute left-0 top-full z-[60] flex max-h-[75dvh] w-full flex-col items-center overflow-y-auto border-b border-cyan-500/10 bg-[#020817]/95 py-4 backdrop-blur-2xl md:hidden"
            >
              <Link
                to="/domain"
                className="block w-full py-3 text-center text-base font-semibold text-slate-100 transition-all duration-300 hover:bg-cyan-500/10 hover:text-cyan-300"
                onClick={() => setMenuOpen(false)}
              >
                Domain
              </Link>
              <Link
                to="/email"
                className="block w-full py-3 text-center text-base font-semibold text-slate-100 transition-all duration-300 hover:bg-cyan-500/10 hover:text-cyan-300"
                onClick={() => setMenuOpen(false)}
              >
                Email
              </Link>
              <Link
                to="/hosting"
                className="block w-full py-3 text-center text-base font-semibold text-slate-100 transition-all duration-300 hover:bg-cyan-500/10 hover:text-cyan-300"
                onClick={() => setMenuOpen(false)}
              >
                Website Engagement
              </Link>
              <Link
                to="/ppc"
                className="block w-full py-3 text-center text-base font-semibold text-slate-100 transition-all duration-300 hover:bg-cyan-500/10 hover:text-cyan-300"
                onClick={() => setMenuOpen(false)}
              >
                PPC
              </Link>
              <Link
                to="/seo"
                className="block w-full py-3 text-center text-base font-semibold text-slate-100 transition-all duration-300 hover:bg-cyan-500/10 hover:text-cyan-300"
                onClick={() => setMenuOpen(false)}
              >
                SEO
              </Link>
              <Link
                to="/services"
                className="block w-full py-3 text-center text-base font-semibold text-slate-100 transition-all duration-300 hover:bg-cyan-500/10 hover:text-cyan-300"
                onClick={() => setMenuOpen(false)}
              >
                Website Development
              </Link>
              <Link
                to="/ssl"
                className="block w-full py-3 text-center text-base font-semibold text-slate-100 transition-all duration-300 hover:bg-cyan-500/10 hover:text-cyan-300"
                onClick={() => setMenuOpen(false)}
              >
                SSL
              </Link>
              <Link
                to="/mobile-app-developments"
                className="block w-full py-3 text-center text-base font-semibold text-slate-100 transition-all duration-300 hover:bg-cyan-500/10 hover:text-cyan-300"
                onClick={() => setMenuOpen(false)}
              >
                Android/iOS App Development
              </Link>
              <Link
                to="/existing-projects-updates"
                className="block w-full py-3 text-center text-base font-semibold text-slate-100 transition-all duration-300 hover:bg-cyan-500/10 hover:text-cyan-300"
                onClick={() => setMenuOpen(false)}
              >
                Existing Project Updates
              </Link>

              {token && (
                <Link
                  to="/my-domains"
                  className="block w-full py-3 text-center text-base font-bold text-cyan-300 transition-all duration-300 hover:bg-cyan-500/10 hover:text-cyan-200"
                  onClick={() => setMenuOpen(false)}
                >
                  My Domains
                </Link>
              )}

              {token && (
                <Link
                  to="/my-mailboxes"
                  className="block w-full py-3 text-center text-base font-bold text-fuchsia-300 transition-all duration-300 hover:bg-fuchsia-500/10 hover:text-fuchsia-200"
                  onClick={() => setMenuOpen(false)}
                >
                  My Mailboxes
                </Link>
              )}
            </div>
          </>
        )}

      </nav>

    </div>
  );
};

export default Navbar;
